'use strict';
const angular = require('angular');

export class assetPermissionComponent {
  /*@ngInject*/
  constructor(Config, StorageService) {
    this.StorageService = StorageService;

    this.roles = Config.getPlatformConfig().getPermissionRoles();
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.asset = this.config.asset;
    this.asset.permissionModel = {};

    this.roles.forEach(role => {
      this.asset.permissionModel[role] = this.asset.permission && this.asset.permission.indexOf(role) !== -1;
    });
  };

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  isHtmlMime(mime) {
    return mime == 'text/html';
  }

  ok() {

    // Permission is empty when file is public
    let permission = [];

    // ... otherwise we have to build the array with permission roles from the model
    if (!this.asset.isPublic) {
      for (let role in this.asset.permissionModel) {
        if (this.asset.permissionModel.hasOwnProperty(role)) {
          if (this.asset.permissionModel[role] === true){
            permission.push(role);
          }
        }
      }
    }

    this.StorageService.update({id: this.asset._id}, {
      isPublic: this.asset.isPublic,
      permission: permission
    }, () => {
      this.close({$value: 'ok'});
    });
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduu.sm.asset.permission', [])
  .component('assetPermission', {
    template: require('./asset-permission.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: assetPermissionComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~sm/components/asset/permission/asset-permission.component.js